import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(4),
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: -8,
    left: '50%',
    transform: 'translateX(-50%)',
    width: '60px',
    height: '3px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '2px',
  }
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  textTransform: 'uppercase',
  marginBottom: theme.spacing(2),
  fontWeight: 600,
  color: theme.palette.text.primary,
  fontSize: '1.1rem',
  display: 'flex',
  alignItems: 'center',
  '&::before': {
    content: '""',
    display: 'inline-block',
    width: '4px',
    height: '16px',
    backgroundColor: theme.palette.primary.main,
    marginRight: '8px',
    borderRadius: '2px',
  }
})); 